import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button,Text, VStack } from '@chakra-ui/react';

const PageNotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="50vh"
    >
      <VStack spacing={4}>
        <Text fontSize="6xl" fontWeight="bold" color="gray.400">
          404
        </Text>
        <Text fontSize="xl" color="gray.600">
          Page Not Found
        </Text>
        <Button colorScheme="blue" onClick={() => navigate('/')}>
          Go Home
        </Button>
      </VStack>
    </Box>
  );
};

export default PageNotFound; 